export default {
  methods: {
    readFile(file) {
      return new Promise((resolve, reject) => {
        let content = ''
        const reader = new FileReader()
        if (typeof FileReader === 'undefined') {
          this.$Message.warning(this.$t('upload.unsupportReadOnBrower'))
          return false
        }
        reader.readAsText(file, 'UTF-8')
        reader.onerror = (err) => {
          this.$Message.warning(this.$t('upload.readFileError'))
          reject(err)
        }
        reader.onload = (ev) => {
          content = ev.target.result
          resolve(ev.target.result)
        }
        return content
      })
    },

    downloadFile(responseHeaders, blobData, file) {
      if (!responseHeaders) return

      if (responseHeaders['content-type'] === 'application/octet-stream') {
        // filname key
        const { fileName, fileNameKey } = file
        const nameKey = fileNameKey || 'filename'
        const fileNameReg = new RegExp(`${nameKey}=(.*)`)

        // file name
        const fileNames = responseHeaders['content-disposition']
        const nameKeyValue = fileNames.match(fileNameReg)
        let name = nameKeyValue ? nameKeyValue[1] : fileName || 'default'
        name = decodeURIComponent(name)

        // download
        if ('download' in document.createElement('a')) {
          // not IE
          const url = window.URL.createObjectURL(new Blob([blobData], { type: 'application/json' }))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', name)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        } else {
          // IE 10+
          navigator.msSaveBlob(new Blob([blobData]), name)
        }
      }
    },
  },
}
